import { errorMessages } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Create, SimpleForm, useNotify, useStore } from "react-admin";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import CreateForm from "./CreateForm";

const STORE_KEY = "internshipFreeSelectionSchedule.filters";

const CreateScheduleFreeSelectionSlot = () => {
  const [filters] = useStore(STORE_KEY, null);
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();

  const transform = data => ({
    internshipSessionId: data.internshipSessionId,
    planId: data.planId,
    disciplineId: data.disciplineId,
    roomId: data.roomId,
    roomCapacity: data.roomCapacity,
    intervals: data.intervals,
  });

  return (
    <>
      <Create
        title="Създаване на свободен избор разписание"
        actions={<BackButtonToolbar />}
        transform={transform}
        onError={e => {
          const errorMessage = e.message || errorMessages[e.errorCode];
          notify(errorMessage, { type: "error" });
          handleConflictError(e);
        }}
      >
        <SimpleForm
          toolbar={<InactiveDeleteOptionEditToolbar />}
          defaultValues={{
            academicYearId: filters?.academicYearId,
            structuralUnitId: filters?.structuralUnitId,
            internshipSessionId: filters?.internshipSessionId,
            planId: filters?.planId,
          }}
        >
          <CreateForm filters={filters} />
        </SimpleForm>
      </Create>
      <ConflictErrorDialog />
    </>
  );
};

export default CreateScheduleFreeSelectionSlot;
